import {
  append, clone, concat, findIndex, merge, propEq, reject
} from 'ramda';
import {
  DELETE_JOB_DONE_REQUEST,
  DELETE_JOB_DONE_SUCCESS,
  DELETE_JOB_DONE_FAIL,
  LOAD_TOTAL_WORK_IN_PERIOD_REQUEST,
  LOAD_TOTAL_WORK_IN_PERIOD_SUCCESS,
  LOAD_TOTAL_WORK_IN_PERIOD_FAIL,
  LOAD_USER_JOBS_IN_DAY_REQUEST,
  LOAD_USER_JOBS_IN_DAY_SUCCESS,
  LOAD_USER_JOBS_IN_DAY_FAIL,
  LOAD_USER_JOBS_IN_PERIOD_REQUEST,
  LOAD_USER_JOBS_IN_PERIOD_SUCCESS,
  LOAD_USER_JOBS_IN_PERIOD_FAIL,
  LOAD_CALENDAR_EVENTS_REQUEST,
  LOAD_CALENDAR_EVENTS_SUCCESS,
  LOAD_CALENDAR_EVENTS_FAIL,
  UPDATE_MANY_USERS_JOBS_IN_PERIOD,
  LOAD_USER_JOBS_REQUEST,
  LOAD_USER_JOBS_SUCCESS,
  LOAD_USER_JOBS_FAIL,
  POST_NEW_CALENDAR_EVENT_REQUEST,
  POST_NEW_CALENDAR_EVENT_SUCCESS,
  POST_NEW_CALENDAR_EVENT_FAIL,
  PUT_JOB_DONE_REQUEST,
  PUT_JOB_DONE_SUCCESS,
  PUT_JOB_DONE_FAIL,
  LOAD_FAULTY_EVENTS_REQUEST,
  LOAD_FAULTY_EVENTS_SUCCESS,
  LOAD_FAULTY_EVENTS_FAIL,
  UPDATE_OVER_TIMES_REQUEST,
  UPDATE_OVER_TIMES_SUCCESS,
  UPDATE_OVER_TIMES_FAIL,
  GENERATE_WORK_HOURS_REQUEST,
  GENERATE_WORK_HOURS_SUCCESS,
  GENERATE_WORK_HOURS_FAIL,
  DELETE_MULTIPLE_JOBS_SUCCESS,
  DELETE_MULTIPLE_JOBS_FAIL,
  DELETE_MULTIPLE_JOBS_REQUEST,
  UPDATE_USER_CURRENT_ACTIVITY,
  DELETE_USER_CURRENT_ACTIVITY,
  TIME_TABLE_LAW_CHECK_REQUEST,
  TIME_TABLE_LAW_CHECK_SUCCESS,
  TIME_TABLE_LAW_CHECK_FAIL,
  TIME_TABLE_LAW_CHECK_RESET
} from 'src/store/actions/calendarActions';

const initialState = {
  fetching: 0,
  userJobs: [],
  faultyEvents: [],
  userJobsInPeriod: [],
  totalUsersJobsInPeriod: [],
  totalCalendarHoursInPeriod: {},
  originPlannerEvent: [],
  userJobsInDay: [],
  errors: [],
  totalWorkInPeriod: [],
  success: false,
  generateFetching: false,
  multipleDeleteFetching: false,
  userCurrentActivities: {},
  lawsCompliance: [],
  lawsComplianceFetching: false
};

const addOrReplaceInList = (filter, prop, list, DepartmentName) => {
  let works = clone(list);
  filter.forEach((work) => {
    if (work.IsDeleted) {
      works = reject(propEq(prop, work[prop]), works);
    } else if (findIndex(propEq(prop, work[prop]), works) >= 0) {
      const updatedIndex = findIndex(propEq(prop, work[prop]), works);
      works[updatedIndex] = { ...works[updatedIndex], ...work, DepartmentName };
    } else works = append(merge(work, { DepartmentName }), works);
  });
  return works;
};

const getNewUserCurrentActivitiesMap = (state, userId, newUserCurrentActivity) => {
  const existingActivitiesCopy = { ...state.userCurrentActivities };
  existingActivitiesCopy[userId] = newUserCurrentActivity;
  return { ...existingActivitiesCopy };
};

const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_FAULTY_EVENTS_REQUEST:
      return merge(state, { fetching: state.fetching + 1, errors: [] });
    case LOAD_FAULTY_EVENTS_SUCCESS:
      return merge(state, { faultyEvents: action.faultyEvents, fetching: state.fetching - 1, errors: [] });
    case LOAD_FAULTY_EVENTS_FAIL:
      return merge(state, { fetching: state.fetching - 1, errors: [action.error] });
    case GENERATE_WORK_HOURS_REQUEST:
      return merge(state, { generateFetching: true });
    case GENERATE_WORK_HOURS_SUCCESS:
      return merge(state, { generateFetching: false });
    case GENERATE_WORK_HOURS_FAIL:
      return merge(state, { generateFetching: false });
    case UPDATE_OVER_TIMES_REQUEST:
      return merge(state, { fetching: state.fetching + 1, errors: [] });
    case UPDATE_OVER_TIMES_SUCCESS:
      return merge(state, { fetching: state.fetching - 1, errors: [] });
    case UPDATE_OVER_TIMES_FAIL:
      return merge(state, { fetching: state.fetching - 1, errors: [action.error] });
    case LOAD_USER_JOBS_REQUEST:
      return merge(state, { fetching: state.fetching + 1, errors: [] });
    case LOAD_USER_JOBS_SUCCESS:
      return merge(state, { userJobs: action.userJobs, fetching: state.fetching - 1, errors: [] });
    case LOAD_USER_JOBS_FAIL:
      return merge(state, { fetching: state.fetching - 1, errors: [action.error] });
    case LOAD_USER_JOBS_IN_PERIOD_REQUEST:
      return { ...state, fetching: state.fetching + 1, errors: [] };
    case LOAD_USER_JOBS_IN_PERIOD_SUCCESS:
      return merge(state, { userJobsInPeriod: action.userJobsInPeriod, fetching: state.fetching - 1, errors: [] });
    case LOAD_USER_JOBS_IN_PERIOD_FAIL:
      return merge(state, { fetching: state.fetching - 1, errors: [action.error] });
    case LOAD_CALENDAR_EVENTS_REQUEST:
      return merge(state, { fetching: state.fetching + 1, errors: [] });
    case LOAD_CALENDAR_EVENTS_SUCCESS:
      return merge(state, { calendarEvents: action.calendarEvents, fetching: state.fetching - 1, errors: [] });
    case LOAD_CALENDAR_EVENTS_FAIL:
      return merge(state, { fetching: state.fetching - 1, errors: [action.error], manyUsersJobsInPeriod: [] });
    case UPDATE_MANY_USERS_JOBS_IN_PERIOD:
      return merge(state, { totalUsersJobsInPeriod: action.payload });
    case LOAD_USER_JOBS_IN_DAY_REQUEST:
      return merge(state, { fetching: state.fetching + 1, errors: [] });
    case LOAD_USER_JOBS_IN_DAY_SUCCESS:
      return merge(state, { userJobsInDay: action.userJobsInDay, fetching: state.fetching - 1, errors: [] });
    case LOAD_USER_JOBS_IN_DAY_FAIL:
      return merge(state, { fetching: state.fetching - 1, errors: [action.error] });
    case LOAD_TOTAL_WORK_IN_PERIOD_REQUEST:
      return merge(state, { fetching: state.fetching + 1, errors: [] });
    case LOAD_TOTAL_WORK_IN_PERIOD_SUCCESS:
      return merge(state, { totalWorkInPeriod: action.userJobs, fetching: state.fetching - 1, errors: [] });
    case LOAD_TOTAL_WORK_IN_PERIOD_FAIL:
      return merge(state, { fetching: state.fetching - 1, errors: [action.error] });
    case PUT_JOB_DONE_REQUEST:
      return merge(state, { fetching: state.fetching + 1, errors: [] });
    case PUT_JOB_DONE_SUCCESS:
      return merge(state, {
        fetching: state.fetching - 1,
        errors: [],
        userJobsInPeriod: addOrReplaceInList(action.jobDone, 'Id', state.userJobsInPeriod, action.params.DepartmentName)
      });
    case PUT_JOB_DONE_FAIL:
      return merge(state, { fetching: state.fetching - 1, errors: [action.error] });
    case DELETE_JOB_DONE_REQUEST:
      return merge(state, { fetching: state.fetching + 1, success: false });
    case DELETE_JOB_DONE_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: state.fetching - 1,
        userJobsInPeriod: reject(propEq('Id', action.eventCalendarId), state.userJobsInPeriod),
        userJobsInDay: reject(propEq('Id', action.eventCalendarId), state.userJobsInDay),
        faultyEvents: reject(propEq('Id', action.eventCalendarId), state.faultyEvents),
        success: true
      });
    case DELETE_JOB_DONE_FAIL:
      return merge(state, {
        fetching: state.fetching - 1,
        errors: [action.error]
      });
    case POST_NEW_CALENDAR_EVENT_REQUEST:
      return merge(state, { fetching: state.fetching + 1, errors: [], success: false });
    case POST_NEW_CALENDAR_EVENT_SUCCESS:
      return merge(state, {
        userJobsInPeriod: concat(state.userJobsInPeriod, [merge(action.calendarEvent, { DepartmentName: action.departmentName })]),
        fetching: state.fetching - 1,
        errors: [],
        success: true
      });
    case POST_NEW_CALENDAR_EVENT_FAIL:
      return merge(state, { fetching: state.fetching - 1, errors: [action.error] });
    case DELETE_MULTIPLE_JOBS_REQUEST:
      return merge(state, { multipleDeleteFetching: true });
    case DELETE_MULTIPLE_JOBS_SUCCESS:
      return merge(state, {
        multipleDeleteFetching: false,
        faultyEvents: state.faultyEvents.filter(({ Id }) => !action.eventCalendarIds.includes(Id))
      });
    case DELETE_MULTIPLE_JOBS_FAIL:
      return merge(state, { multipleDeleteFetching: false, errors: [action.error] });
    case UPDATE_USER_CURRENT_ACTIVITY:
      return {
        ...state,
        userCurrentActivities: getNewUserCurrentActivitiesMap(state, action.userId, action.userCurrentActivity)
      };
    case DELETE_USER_CURRENT_ACTIVITY:
      return { ...state, userCurrentActivities: getNewUserCurrentActivitiesMap(state, action.userId, null) };
    case TIME_TABLE_LAW_CHECK_REQUEST:
      return ({ ...state, lawsComplianceFetching: true });
    case TIME_TABLE_LAW_CHECK_SUCCESS:
      return ({ ...state, lawsComplianceFetching: false, lawsCompliance: action.payload });
    case TIME_TABLE_LAW_CHECK_FAIL:
      return ({ ...state, lawsComplianceFetching: false });
    case TIME_TABLE_LAW_CHECK_RESET:
      return ({ ...state, lawsCompliance: [] });
    default:
      return state;
  }
};

export default calendarReducer;
